import { z } from 'zod';
import { Note } from './Note';

const { noteSchema } = Note();

const contactNotesSchema = z.object({
  id: z.number().positive(),
  notes: z.array(noteSchema),
});

export type ContactNotesSchema = z.infer<typeof contactNotesSchema>;

export type ContactNotesErrors = {
  [K in keyof ContactNotesSchema]?: string;
}

export const ContactNotes = () =>
  ({
    contactNotesSchema,
  })
;
